import { DocumentSignerKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetDocumentSignDocsPdfPageRequest, GetDocumentSignDocsPdfPageResponse } from "@maven-rest/docs/DocumentSigner.dto";
import { DocumentSignerUrl } from "@maven-rest/docs/DocumentSigner.url";

export function useDocumentSignerDocsPdfPageQuery(
  req: GetDocumentSignDocsPdfPageRequest,
  options?: SimpleQueryOptions<GetDocumentSignDocsPdfPageResponse, GetDocumentSignDocsPdfPageRequest>
) {
  return useBaseQuery({
    queryKey: [
      DocumentSignerKey.DocumentSignerDocsPdfPage,
      req.token,
      String(req.docsPdfId),
      req.page,
      req.documentAccessRequesterType,
      String(req.documentId),
    ],
    fnOption: { url: DocumentSignerUrl.getDocumentSignDocsPdfPage(req.token), request: req },
    ...options,
  });
}
